var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2742 14.8226C13.8776 14.8226 15.1774 13.5227 15.1774 11.9193C15.1774 10.3159 13.8776 9.01611 12.2742 9.01611C10.6708 9.01611 9.37097 10.3159 9.37097 11.9193C9.37097 13.5227 10.6708 14.8226 12.2742 14.8226Z",
    stroke: "#7B86A0",
    strokeWidth: 1.62581
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1981 10.8879C20.5738 11.344 20.7616 11.572 20.7616 11.9192C20.7616 12.2665 20.5738 12.4945 20.1981 12.9506C18.8238 14.6191 15.7926 17.7257 12.2742 17.7257C8.75577 17.7257 5.7246 14.6191 4.35032 12.9506C3.97468 12.4945 3.78687 12.2665 3.78687 11.9192C3.78687 11.572 3.97468 11.344 4.35032 10.8879C5.7246 9.21938 8.75577 6.11279 12.2742 6.11279C15.7926 6.11279 18.8238 9.21938 20.1981 10.8879Z",
    stroke: "#7B86A0",
    strokeWidth: 1.62581
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/viewIcon.772b47780b6883082af446ae923c2c42.svg";
export { ForwardRef as ReactComponent };